const initialState = {    
    asideBg: false,
    asideColapsed: false,
    asideToggled: false,
    darkTheme: false,
    customInvoiceFile: "" ,
    generickiPredlozakRacuna: true
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    
    case "CUSTOM_INVOICE_FILE":
        return{
            ...state,
            customInvoiceFile: action.data,
            generickiPredlozakRacuna: false
        }

    case "GENERICKI_PREDLOZAK_RACUNA":
        return{
            ...state,
            generickiPredlozakRacuna: !state.generickiPredlozakRacuna
        }

    case "DARK_THEME_TOGGLER":
        return{
            ...state,
            darkTheme: !state.darkTheme
        }

    case "ASIDE_TOGGLER":
        return{
            ...state,
            asideToggled: action.data
        }
    case "ASIDE_COLAPSED":
        return{
            ...state,
            asideColapsed: !state.asideColapsed
        }

    case "ASIDE_BG":
        return{
            ...state,
            asideBg: !state.asideBg
        }


    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
